import { Box, type SxProps, type Theme } from "@mui/material";
import type { ReactNode } from "react";
import { reportLayoutTokens } from "./tokens";

export type ReportSectionCardProps = {
  children: ReactNode;
  id?: string;
  className?: string;
  sx?: SxProps<Theme>;
};

/**
 * Bordered, rounded card wrapper for the report table area.
 */
const ReportSectionCard = ({
  children,
  id,
  className,
  sx,
}: ReportSectionCardProps) => {
  return (
    <Box
      id={id}
      className={className}
      sx={{
        border: reportLayoutTokens.cardBorder,
        borderRadius: reportLayoutTokens.cardRadius,
        // overflow:visible — "hidden" breaks StickyHeader tables (thead overlays/cuts tbody rows)
        bgcolor: "#fff",
        ...sx,
      }}
    >
      {children}
    </Box>
  );
};

export default ReportSectionCard;
